import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ProductSummary = ({ showDetails, searchTerm }) => {
    const productSummmary = useSelector(
        (state) => state.posReportshiftSlice.shiftReport);
    const decimalPosition = localStorage.getItem("decimalPosition");
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (index) => {
        setExpandedRows((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    const mainColCount = showDetails ? 4 : 3;

    const filteredSale = productSummmary?.sale?.filter((r) => {
        if (!searchTerm) return true;
        const term = searchTerm.toLowerCase();
        if (r.productName?.toLowerCase().includes(term)) return true;
        if (r.recipeComponents?.some((c) => c.productName?.toLowerCase().includes(term))) return true;
        return false;
    });

    return (
        <div className="new-global-table-container" style={{ paddingTop: "0 42px" }}>
            <table>
                <thead>
                    <tr>
                        {showDetails && <th style={{ width: "30px" }}></th>}
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredSale?.length > 0 ? filteredSale?.map((r, i) => (
                        <React.Fragment key={i}>
                            <tr style={{ backgroundColor: i % 2 === 0 ? "white" : "#e9e7e7", cursor: showDetails ? "pointer" : "default" }}
                                onClick={() => showDetails && r.recipeComponents?.length > 0 && toggleRow(i)}>
                                {showDetails && (
                                    <td style={{ border: "none", height: "29px", width: "30px", textAlign: "center", padding: 0 }}>
                                        {r.recipeComponents?.length > 0 && (
                                            expandedRows[i]
                                                ? <KeyboardArrowUpIcon style={{ fontSize: "18px", color: "#7a5cfa" }} />
                                                : <KeyboardArrowDownIcon style={{ fontSize: "18px", color: "#7a5cfa" }} />
                                        )}
                                    </td>
                                )}
                                <td style={{ border: "none", height: "29px" }}>{r.productName}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.totalQty}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.amount}</td>
                            </tr>
                            {showDetails && expandedRows[i] && r.recipeComponents?.length > 0 && (
                                <tr>
                                    <td colSpan={mainColCount} style={{ padding: 0, border: "none" }}>
                                        <table style={{ width: "85%", margin: "4px auto 8px", borderCollapse: "collapse", tableLayout: "fixed" }}>
                                            <colgroup>
                                                <col style={{ width: "6%" }} />
                                                <col style={{ width: "52%" }} />
                                                <col style={{ width: "20%" }} />
                                                <col style={{ width: "22%" }} />
                                            </colgroup>
                                            <thead>
                                                <tr style={{ backgroundColor: "#eee8f5" }}>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "center", borderBottom: "1px solid #ddd" }}>#</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "left", borderBottom: "1px solid #ddd" }}>Component</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "center", borderBottom: "1px solid #ddd" }}>Qty</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "center", borderBottom: "1px solid #ddd" }}>Unit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {r.recipeComponents.map((comp, idx) => (
                                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#faf9ff" : "#f3f1fa" }}>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "center" }}>{idx + 1}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "left" }}>{comp.productName}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "center" }}>{comp.quantity}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "center" }}>{comp.uomName}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    )) : (
                        <tr>
                            <td colSpan={mainColCount}>NO DATA</td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr style={{ backgroundColor: "rgb(150 148 148)" }}>
                        <td colSpan={mainColCount - 1} style={{ textAlignLast: "end", paddingInline: "10px" }}>TOTAL</td>
                        <td style={{ textAlignLast: "center" }}>{(filteredSale || []).reduce((acc, current) => acc + Number(current?.amount || 0), 0)?.toFixed(decimalPosition)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default ProductSummary